<template>
  <div class="row">
    <div class="col-sm-12 mb-3">
      <span v-if="user.virtual_phone_number">User virtual number: {{ user.virtual_phone_number.substring(2).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') }}</span>
      <span v-else>No virtual number associated with user.</span>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <ActionToolbar
        :primary-style="user.virtual_phone_number ? 'danger' : 'success'"
        :secondary-enabled="false"
        :component-state="currentState"
        :error-message="formError"
        :success-message="successMessage"
        :primary-disabled="user.deactivated_at && !user.virtual_phone_number"
        :primary-button-text="user.virtual_phone_number ? 'Remove number' : 'Associate a number'"
        @primary-click.prevent="onSubmit()"

        :tertiary-enabled="true"
        tertiary-button-text="Test Virtual Number"
        tertiary-style="primary"
        :tertiary-disabled="!isVirtualPhoneTestButtonEnabled"
        @tertiary-click="testVirtualPhoneCall"
      />
    </div>
  </div>
</template>

<script>
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useUserStore } from '@/src/stores/user';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
export default {
  components: {
    ActionToolbar
  },
  mixins: [savableStateMixin],
  props: {
    user: { required: true, type: Object }
  },
emits: ['update'],
  setup() {
    const userStore = useUserStore();
    return {
      userStore
    }
  },
  data() {
    return {
      successMessage: null,
    }
  },
  computed: {
    isVirtualPhoneTestButtonEnabled() {
      // Test button is enabled only if the values is saved.
      return !!this.user.virtual_phone_number && !!this.user.phone_number;
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.successMessage = "Saved Successfully!";
        this.setSavableStateProcessing();
        let response;
        if (this.user.virtual_phone_number) {
          response = await this.userStore.removeVirtualNumber(this.user.id);
        } else {
          response = await this.userStore.addVirtualNumber(this.user.id);
        }
        this.$emit('update', response);
        this.setSavableStateSuccess()
      } catch (error) {
        this.handleFormError(error);
      }
    },
    async testVirtualPhoneCall() {
      this.setSavableStateProcessing();
      try {
        await this.userStore.testVirtualPhoneCall(this.user.id);
        this.successMessage = "You should receive a phone call within a few seconds";
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },   
  }
}
</script>